import { render } from "./TimelineSection2.vue?vue&type=template&id=2b5a5703&scoped=true"
import script from "./TimelineSection2.vue?vue&type=script&lang=js"
export * from "./TimelineSection2.vue?vue&type=script&lang=js"

import "./TimelineSection2.vue?vue&type=style&index=0&id=2b5a5703&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5a5703"]])

export default __exports__